


// import React from 'react';
// import '../styles/CorePrinciples.css';
// import performanceIcon from '../../../../assets/solutions/applicationdevelopment/Performance.svg';
// import aiIcon from '../../../../assets/solutions/applicationdevelopment/AiEnablement.svg';
// import architectureIcon from '../../../../assets/solutions/applicationdevelopment/CleanArchitecture.svg';
// import agileIcon from '../../../../assets/solutions/applicationdevelopment/AgileDelivery.svg';

// const CorePrinciples = () => {
//   return (
//     <section className="section-best-practices">
//       <div className="container">
//         <div className="section-header text-center reveal">
//           <h2 className="section-tag">CORE PRINCIPLES</h2>
//           <h3>App Modernization Excellence</h3>
//         </div>
//         <div className="practices-grid">
//           {/* Clean Architecture */}
//           <div className="practice-item clean-architecture reveal">
//             <div className="practice-icon-wrapper">
//               <img src={architectureIcon} className='core-icons' alt="Clean Architecture Icon" />
//             </div>
//             <h4>Clean Architecture</h4>
//             <p>
//               Strict separation of concerns to ensure code maintainability for the next decade of growth.
//             </p>
//           </div>

//           {/* Performance-First */}
//           <div className="practice-item performance-first reveal-delayed">
//             <div className="practice-icon-wrapper">
//               <img src={performanceIcon} className='core-icons' alt="Performance-First Icon" />
//             </div>
//             <h4>Performance-First</h4>
//             <p>
//               Sub-second interaction design. We optimize every millisecond of the software execution stack.
//             </p>
//           </div>

//           {/* AI Enablement */}
//           <div className="practice-item ai-enablement reveal-more">
//             <div className="practice-icon-wrapper">
//               <img src={aiIcon} className='core-icons' alt="AI Enablement Icon" />
//             </div>
//             <h4>AI Enablement</h4>
//             <p>
//               APIs built for the agentic age. Modernized for seamless LLM and generic AI integration.
//             </p>
//           </div>

//           {/* Agile Delivery */}
//           <div className="practice-item agile-delivery reveal">
//             <div className="practice-icon-wrapper">
//               <img src={agileIcon} className='core-icons' alt="Agile Delivery Icon" />
//             </div>
//             <h4>Agile Delivery</h4>
//             <p>
//               Modernized team workflows that remove developer friction and accelerate shipment speed.
//             </p>
//           </div>
//         </div>

//         {/* Differentiation Note (Left-Aligned) */}
//         <div className="differentiation-note reveal-more">
//           <p>
//             Primarily focused on infrastructure? Explore our <a href="/solutions/cloud-adoption">Cloud Adoption & Migration Solutions</a> instead.
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CorePrinciples;


















import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import '../styles/CorePrinciples.css';
import performanceIcon from '../../../../assets/solutions/applicationdevelopment/Performance.svg';
import aiIcon from '../../../../assets/solutions/applicationdevelopment/AiEnablement.svg';
import architectureIcon from '../../../../assets/solutions/applicationdevelopment/CleanArchitecture.svg';
import agileIcon from '../../../../assets/solutions/applicationdevelopment/AgileDelivery.svg';

const CorePrinciples = () => {
  return (
    <section className="section-best-practices">
      <div className="container">
        <div className="section-header text-center reveal">
          <h2 className="section-tag">CORE PRINCIPLES</h2>
          <h3>App Modernization Excellence</h3>
        </div>
        
        <div className="practices-grid">
          {/* Clean Architecture */}
          <div className="practice-item clean-architecture reveal">
            <div className="practice-icon-wrapper">
              <img src={architectureIcon} className='core-icons' alt="Clean Architecture Icon" />
            </div>
            <h4>Clean Architecture</h4>
            <p>
              Strict separation of concerns to ensure code maintainability for the next decade of growth.
            </p>
          </div>

          {/* Performance-First */}
          <div className="practice-item performance-first reveal-delayed">
            <div className="practice-icon-wrapper">
              <img src={performanceIcon} className='core-icons' alt="Performance-First Icon" />
            </div>
            <h4>Performance-First</h4>
            <p>
              Sub-second interaction design. We optimize every millisecond of the software execution stack.
            </p>
          </div>

          {/* AI Enablement */}
          <div className="practice-item ai-enablement reveal-more">
            <div className="practice-icon-wrapper">
              <img src={aiIcon} className='core-icons' alt="AI Enablement Icon" />
            </div>
            <h4>AI Enablement</h4>
            <p>
              APIs built for the agentic age. Modernized for seamless LLM and generic AI integration.
            </p>
          </div>

          {/* Agile Delivery */}
          <div className="practice-item agile-delivery reveal">
            <div className="practice-icon-wrapper">
              <img src={agileIcon} className='core-icons' alt="Agile Delivery Icon" />
            </div>
            <h4>Agile Delivery</h4>
            <p>
              Modernized team workflows that remove developer friction and accelerate shipment speed.
            </p>
          </div>
        </div>

        {/* Differentiation Note - Updated with <Link> */}
        <div className="differentiation-note reveal-more">
          <p>
            Primarily focused on infrastructure? Explore our{' '}
            <Link to="/solutions/cloud-adoption" className="modernization-link">
              Cloud Adoption & Migration Solutions
            </Link>{' '}
            instead.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CorePrinciples;